import { render, staticRenderFns } from "./task.vue?vue&type=template&id=3ffaf3c2&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=3ffaf3c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffaf3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffaf3c2')) {
      api.createRecord('3ffaf3c2', component.options)
    } else {
      api.reload('3ffaf3c2', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=3ffaf3c2&scoped=true", function () {
      api.rerender('3ffaf3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/taskList/task.vue"
export default component.exports